import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {TokenService} from "../auth/token-service/token.service";

/**
 * Adds Authorization header with token depending on user role
 */
@Injectable()
export class MockAuthTokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    const tokenService = inject(TokenService);

    const mockJwt = tokenService.getToken();

    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${mockJwt}`
      }
    });

    return handler.handle(cloned);
  }
}
